import { ReactNode, useMemo } from "react";
import { BetslipPebble, SportsbookPlacePanelViewModel, PebblesResolvers } from "./SportsbookPlacePanel.types";

const DEFAULT_PEBBLES: BetslipPebble[] = ["BET_BUILDER", "MULTIPLES", "CAST_BET", "SINGLES", "LOTTERIES"];

type PebblesViewModel = {
  headers: Array<{ id: BetslipPebble; title: string }>;
  contents: Array<{ id: BetslipPebble; content: ReactNode }>;
};

function resolvePebbles({ withAllPebbleEnabled }: SportsbookPlacePanelViewModel): BetslipPebble[] {
  return withAllPebbleEnabled ? ["ALL", ...DEFAULT_PEBBLES] : DEFAULT_PEBBLES;
}

export function usePebblesViewModel(
  props: SportsbookPlacePanelViewModel,
  pebblesResolvers: PebblesResolvers,
): PebblesViewModel {
  return useMemo(() => {
    const pebbles = resolvePebbles(props).filter((pebble) => pebblesResolvers[pebble].visible(props));

    const headers = pebbles.map((pebble) => ({ id: pebble, title: pebblesResolvers[pebble].title(props) }));
    const contents = pebbles.map((pebble) => {
      return {
        id: pebble,
        content: pebblesResolvers[pebble].content(props),
      };
    });

    return {
      headers,
      contents,
    };
  }, [props, pebblesResolvers]);
}
